import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal
} from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { SnackbarNotificationService } from "../../services/snackbar-notification/snackbar-notification.service";
import { Notification } from "../../types/notifications.type";
import { SnackbarComponent } from "../snackbar/snackbar.component";

@Component({
  selector: "app-snackbar-notification",
  imports: [SnackbarComponent],
  templateUrl: "./snackbar-notification.component.html",
  styleUrl: "./snackbar-notification.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarNotificationComponent {
  private readonly snackbarNotificationService = inject(
    SnackbarNotificationService
  );

  readonly notifications = signal<Notification[]>([]);

  private readonly fadeTime: number =
    environment.ui.notificationsDuration ?? 5000;

  constructor() {
    this.snackbarNotificationService.notification.subscribe((notification) => {
      if (!notification) {
        this.notifications.set([]);
        return;
      }
      this.notifications.update((notifications) => [
        ...notifications,
        notification
      ]);
      setTimeout(() => {
        this.removeNotification(notification);
      }, this.fadeTime);
    });
  }

  removeNotification(notification: Notification): void {
    this.notifications.update((notifications) => {
      notification.removeAnimation = true;
      return [...notifications];
    });

    setTimeout(() => {
      this.notifications.update((notifications) =>
        notifications.filter((x) => x !== notification)
      );
    }, 250); // Slighlt less than the time of the remove animation
  }
}
